import React from "react";

import { useHistory } from "react-router-dom";

import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";

import Icon from "@material-ui/core/Icon";
import IconButton from "@material-ui/core/IconButton";

import Styles from "./TableRunningActions.module.css";

const useStyles = makeStyles((theme) => ({
	tableActions: {
		width: "100%",
	},
}));

const TableRunningActions = (props) => {
	const classes = useStyles();
	const history = useHistory();

	const trainingClasses = [
		...props.TableRunningActionsData.pageData.trainingClasses,
	];

	// console.log("trainingClasses", trainingClasses)

	const iconButtonClickHandler = (item) => {
		history.push("/formacao/courses/actions/details/" + item.id);
	};

	return (
		<div className={Styles["tableActions"]}>
			<Table className={classes.table} aria-label="Actions table">
				<TableHead>
					<TableRow className={Styles["MuiTableRow-head"]}>
						<TableCell
							className={Styles["MuiTableCell-head"]}
							align="left"
						>
							<div className={Styles["title"]}>Nome do Curso</div>
						</TableCell>
						<TableCell
							className={Styles["MuiTableCell-head"]}
							align="left"
						>
							<div className={Styles["title"]}>Data Início</div>
						</TableCell>
						<TableCell
							className={Styles["MuiTableCell-head"]}
							align="left"
						>
							<div className={Styles["title"]}>Data Fim</div>
						</TableCell>
						<TableCell
							className={Styles["MuiTableCell-head"]}
							align="left"
						>
							<div className={Styles["title"]}>Duração</div>
						</TableCell>
						<TableCell
							className={Styles["MuiTableCell-head"]}
							align="left"
						></TableCell>
					</TableRow>
				</TableHead>
				<TableBody>
					{trainingClasses.map((row) => (
						<TableRow
							key={row.id}
							className={Styles["MuiTableBody-root"]}
						>
							<TableCell
								className={Styles["MuiTableCell-root"]}
								align="left"
								component="th"
								scope="row"
							>
								<div className={Styles["subtitle"]}>
									{row.name}
								</div>
							</TableCell>
							<TableCell
								className={Styles["MuiTableCell-root"]}
								align="left"
							>
								<div className={Styles["subtitle"]}>
									{row.shortStartDate}
								</div>
							</TableCell>
							<TableCell
								className={Styles["MuiTableCell-root"]}
								align="left"
							>
								<div className={Styles["subtitle"]}>
									{row.shortEndDate}
								</div>
							</TableCell>
							<TableCell
								className={Styles["MuiTableCell-root"]}
								align="left"
							>
								<div className={Styles["subtitle"]}>
									{row.duration}
								</div>
							</TableCell>
							<TableCell
								className={Styles["MuiTableCell-root"]}
								align="left"
							>
								<div className={Styles["subtitle"]}>
									{row.empty}
									<IconButton
										aria-label="forward"
										onClick={iconButtonClickHandler.bind(
											null,
											row
										)}
									>
										<Icon>arrow_forward_ios</Icon>
									</IconButton>
								</div>
							</TableCell>
						</TableRow>
					))}
				</TableBody>
			</Table>
		</div>
	);
};

export default TableRunningActions;
